import type { ContestStatus } from '../../api/contests';

/**
 * Admin may change contest basics, fixtures, reels, prize tiers, and catalogue outcomes
 * only in these lifecycle states (not while live play is settling prizes, or after finish/cancel).
 */
export const ADMIN_EDITABLE_CONTEST_STATUSES: readonly ContestStatus[] = [
  'draft',
  'upcoming',
  'open',
  'paused',
];

export const contestIsEditable = (status: ContestStatus): boolean =>
  ADMIN_EDITABLE_CONTEST_STATUSES.includes(status);

/** Shown when catalogue, reels, prize tiers, or save actions are disabled by contest status. */
export const ADMIN_CONTEST_EDIT_WINDOW_USER_MESSAGE =
  'Editing is only available while the contest is in draft, upcoming, open, or paused.';

export const CANCELLABLE_STATUSES: readonly ContestStatus[] = ['draft', 'upcoming', 'open'];
/**
 * Owned by `contests/lifecycle.ts` since CAE-1541, where the rest of the pause's
 * domain knowledge lives — two copies would be exactly the drift that module
 * exists to stop. Re-exported here so this page's Pause button and the list's
 * row actions keep their import path.
 */
export { PAUSABLE_STATUSES } from '../../contests/lifecycle';
export const RESUMABLE_STATUSES: readonly ContestStatus[] = ['paused'];
